<template>
  <div class="ContratosListado">
    <md-layout md-flex="100" md-align="center" class="m-t-24">
      <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="100" md-flex-large="90" md-flex-xlarge="70">
        <md-table-card class="w-100">
          <md-toolbar>
            <h1 class="md-title">
              Contratos registrados
            </h1>
          </md-toolbar>
          <md-table>
            <md-table-header>
              <md-table-row>
                <md-table-head>Nombre</md-table-head>
                <md-table-head>Tipo</md-table-head>
                <md-table-head>Duración</md-table-head>
                <md-table-head>Estatus</md-table-head>
                <md-table-head>Acciones</md-table-head>
              </md-table-row>
            </md-table-header>
            <md-table-body>
              <md-table-row v-for="contrato in contratos" :key="contrato.id_cnt">
                <md-table-cell>{{contrato.titulo_cnt}}</md-table-cell>
                <md-table-cell>
                  <div v-if="contrato.tipo_cnt==='laboral_guardia'">CONTRATO LABORAL GUARDIA</div>
                  <div v-if="contrato.tipo_cnt==='servicios_monitoreo'">PRESTACIÓN SERVICIOS MONITOREO</div>
                  <div v-if="contrato.tipo_cnt==='servicios_guardias'">PRESTACIÓN SERVICIOS GUARDIAS</div>
                </md-table-cell>
                <md-table-cell>
                  <div v-if="contrato.duracion_cnt === '1'">1 MES</div>
                  <div v-if="contrato.duracion_cnt > 1">{{contrato.duracion_cnt}} MESES</div>
                  <div v-if="contrato.duracion_cnt==='indeterminado'">INDETERMINADO</div>
                </md-table-cell>
                <md-table-cell>{{contrato.estatus_cnt.toUpperCase()}}</md-table-cell>
                <md-table-cell>
                  <md-button class="md-icon-button" @click.native="irAEditarContratos(contrato.id_cnt)">
                    <md-icon>edit</md-icon>
                  </md-button>
                  <md-button class="md-icon-button" @click.native="cambiarEstatusContrato(contrato)">
                    <md-icon v-if="contrato.estatus_cnt != 'activo'">play</md-icon>
                    <md-icon v-else>pause</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table-body>
          </md-table>
        </md-table-card>
      </md-layout>
    </md-layout>
  </div>
</template>

<script>
import sha1 from 'js-sha1'
import md5 from 'blueimp-md5'
import Snackbar from 'node-snackbar'
import $ from "jquery"
import dt from "datatables.net"
export default {
  name: 'ContratosListado',
  methods: {
    obtenerContratos() {
      this.$http.post('contratos', {
        token: this.$session.get('token')
      })
        .then(response => {
          if (response.status === 200 && 'contratos' in response.body) {
            this.contratos = response.body.contratos
          }
        }, response => {
          Snackbar.show({
            text: 'No se pudo establecer conexión con el servidor.',
            actionText: 'Cerrar',
            pos: 'top-right',
            showAction: false,
            backgroundColor: '#F44336',
            actionTextColor: '#FFF'
          });
        });
    },
    cambiarEstatusContrato(c) {
      this.$http.post('contratos/estatus', {
        token: this.$session.get('token'),
        contrato: sha1(md5(c.id_cnt)),
        estatus: c.estatus_ctn,
      })
        .then(response => {
          if (response.status === 200 && 'contratos' in response.body) {
            this.contratos = response.body.contratos
          }
        }, response => {
          Snackbar.show({
            text: 'No se pudo establecer conexión con el servidor.',
            actionText: 'Cerrar',
            pos: 'top-right',
            showAction: false,
            backgroundColor: '#F44336',
            actionTextColor: '#FFF'
          });
        });
    },
    irAEditarContratos(id_cnt) {
      this.$router.push({ name: 'ContratosEditar', params: { contrato: sha1(md5(id_cnt)) } });
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push('/login')
    }
  },
  created() {
    this.obtenerContratos();
  },
  updated() {
    $('.md-table table').DataTable();
  },
  data() {
    return {
      msg: 'ContratosListado',
      contratos: [],
    }

  }
}
</script>


// WEBPACK FOOTER //
// ContratosListado.vue?543096fa